import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksByIdOptions, getOrgPlaybooksByPlaybookIdVersionsByVersionIdOptions, getOrgPlaybooksByPlaybookIdVersionsOptions } from '@onefootprint/fetch-dashboard';
import type { PlaybookVersion } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';
export const SELECTED_VERSION_QUERY_KEY = 'version';
export const usePlaybook = (playbookId, options) => {
  const $ = _c(44);
  const enabled = options?.enabled ?? true;
  let t0;
  if ($[0] !== playbookId) {
    t0 = getOrgPlaybooksByIdOptions({
      path: {
        id: playbookId
      }
    });
    $[0] = playbookId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== enabled || $[3] !== t0) {
    t1 = {
      ...t0,
      enabled
    };
    $[2] = enabled;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getPlaybook = useQuery(t1);
  let t2;
  if ($[5] !== playbookId) {
    t2 = getOrgPlaybooksByPlaybookIdVersionsOptions({
      path: {
        playbookId
      },
      query: {
        pageSize: 100
      }
    });
    $[5] = playbookId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== enabled || $[8] !== t2) {
    t3 = {
      ...t2,
      enabled
    };
    $[7] = enabled;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const getPlaybookVersions = useQuery(t3);
  const [version, setVersion] = useQueryState(SELECTED_VERSION_QUERY_KEY);
  let playbookVersions;
  let selectedVersionNoGraph;
  let t4;
  let t5;
  if ($[10] !== getPlaybookVersions.data?.data || $[11] !== playbookId || $[12] !== version) {
    playbookVersions = getPlaybookVersions.data?.data || [];
    let t6;
    if ($[17] !== version) {
      t6 = playbookVersion => playbookVersion.id === version;
      $[17] = version;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    selectedVersionNoGraph = playbookVersions.find(t6);
    t5 = useQuery;
    t4 = getOrgPlaybooksByPlaybookIdVersionsByVersionIdOptions({
      path: {
        playbookId,
        versionId: selectedVersionNoGraph?.id || ""
      }
    });
    $[10] = getPlaybookVersions.data?.data;
    $[11] = playbookId;
    $[12] = version;
    $[13] = playbookVersions;
    $[14] = selectedVersionNoGraph;
    $[15] = t4;
    $[16] = t5;
  } else {
    playbookVersions = $[13];
    selectedVersionNoGraph = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  const t6 = !!selectedVersionNoGraph?.id;
  let t7;
  if ($[19] !== t4 || $[20] !== t6) {
    t7 = {
      ...t4,
      enabled: t6
    };
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const getPlaybookVersionDetail = t5(t7);
  let t8;
  if ($[22] !== getPlaybookVersionDetail.data || $[23] !== options) {
    t8 = () => {
      if (getPlaybookVersionDetail.data) {
        options?.onChangeVersion?.(getPlaybookVersionDetail.data);
      }
    };
    $[22] = getPlaybookVersionDetail.data;
    $[23] = options;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== getPlaybookVersionDetail.data) {
    t9 = [getPlaybookVersionDetail.data];
    $[25] = getPlaybookVersionDetail.data;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[27] !== playbookVersions || $[28] !== setVersion || $[29] !== version) {
    t10 = () => {
      const selectedVersion = playbookVersions.find(playbookVersion_0 => playbookVersion_0.id === version);
      if (!selectedVersion && playbookVersions.length > 0) {
        const firstVersion = playbookVersions[0];
        setVersion(firstVersion.id);
      }
    };
    t11 = [version, playbookVersions, setVersion];
    $[27] = playbookVersions;
    $[28] = setVersion;
    $[29] = version;
    $[30] = t10;
    $[31] = t11;
  } else {
    t10 = $[30];
    t11 = $[31];
  }
  useEffect(t10, t11);
  let t12;
  if ($[32] !== getPlaybook || $[33] !== getPlaybookVersions) {
    t12 = async () => {
      const [, playbookVersions_0] = await Promise.all([getPlaybook.refetch(), getPlaybookVersions.refetch()]);
      return playbookVersions_0;
    };
    $[32] = getPlaybook;
    $[33] = getPlaybookVersions;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  const refetch = t12;
  const t13 = getPlaybook.isPending || getPlaybookVersions.isPending;
  const t14 = getPlaybook.error || getPlaybookVersions.error;
  let t15;
  if ($[35] !== getPlaybook.data || $[36] !== getPlaybookVersionDetail.data || $[37] !== playbookVersions || $[38] !== refetch || $[39] !== selectedVersionNoGraph || $[40] !== setVersion || $[41] !== t13 || $[42] !== t14) {
    t15 = {
      playbook: getPlaybook.data,
      selectedVersionNoGraph,
      selectedVersion: getPlaybookVersionDetail.data,
      setVersion,
      playbookVersions,
      isPending: t13,
      error: t14,
      refetch
    };
    $[35] = getPlaybook.data;
    $[36] = getPlaybookVersionDetail.data;
    $[37] = playbookVersions;
    $[38] = refetch;
    $[39] = selectedVersionNoGraph;
    $[40] = setVersion;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};